/* eslint @typescript-eslint/no-explicit-any: 0 */
import { is } from "ramda";
export default function tryFunc(f, onError = (_) => undefined) {
    try {
        const r = f();
        if (is(Promise, r)) {
            return r.catch((e) => {
                onError(e);
                return null;
            });
        }
        else {
            return r;
        }
    }
    catch (e) {
        onError(e);
    }
    return null;
}
//# sourceMappingURL=tryFunc.mjs.map